<template>
    <div class="cursor-pointer" @click="$route.query.back ? $router.push($route.query.back) : $router.go(-1)">
        <i-back></i-back>
    </div>
</template>

<script>
    import IBack from "./Icons/IBack";

    export default {
        name: "NavigateBack",
        components: {
            IBack
        }
    }
</script>

<style scoped>

</style>
